(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bkp-pdp-shop-the-look"]) return;
  try {
    
  (() => {
    const sectionEl = document.querySelector(
      '.section-{{ section.id }}'
    );
    if (!sectionEl) return;

    /**
     * After variant-picker fetches + morphs the DOM, listen to the
     * VariantUpdateEvent it dispatches and refresh the ATC button price label.
     *
     * ThemeEvents.variantUpdate is the string key for the event name.
     * From Horizon source: 'variant:update'
     */
    sectionEl.addEventListener('variant:update', (event) => {
      const { resource } = event.detail;
      if (!resource) return;

      // Find the add-to-cart button closest to this variant-picker
      const variantPicker = event.target.closest('variant-picker');
      if (!variantPicker) return;

      const productFormComponent = variantPicker.closest('product-form-component');
      if (!productFormComponent) return;

      const btn = productFormComponent.querySelector('.stl-card__atc');
      if (!btn) return;

      const defaultText = btn.querySelector('.add-to-cart-text--default');
      if (!defaultText) return;

      // Format price using Shopify's money formatter
      const priceFormatted = typeof Shopify !== 'undefined' && Shopify.formatMoney
        ? Shopify.formatMoney(resource.price, Shopify.money_format)
        : (resource.price / 100).toFixed(2);

      // if (resource.available) {
      //   defaultText.innerHTML =
      //     '{{ 'products.product.add_to_cart' | t | default: 'Add to cart' | escape }}'
      //     + '<span class="stl-card__atc-price"> — ' + priceFormatted + '</span>';
      // } else {
      //   defaultText.textContent =
      //     '{{ 'products.product.sold_out' | t | default: 'Sold out' | escape }}';
      // }
    });

    /**
     * Keep the visible "Option — Selected Value" legend text in sync.
     * variant-picker re-renders its own HTML via DOM morphing, so the
     * checked radio state is always accurate. We just mirror it into
     * the legend's .stl-card__option-selected span.
     */
    sectionEl.addEventListener('change', (e) => {
      const input = e.target;
      if (!input.closest('variant-picker')) return;

      const fieldset = input.closest('fieldset');
      if (!fieldset) return;

      const selectedSpan = fieldset.querySelector('.stl-card__option-selected');
      if (!selectedSpan) return;

      const value = input.tagName === 'SELECT'
        ? input.options[input.selectedIndex]?.text
        : input.value;

      if (value) selectedSpan.textContent = ' \u2014 ' + value;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-shop-the-look"]) return;
  try {
    
  (() => {
    const sectionEl = document.querySelector(
      '.shop-the-look.section-{{ section.id }}'
    );
    if (!sectionEl) return;

    /**
     * After variant-picker fetches + morphs the DOM, listen to the
     * VariantUpdateEvent it dispatches and refresh the ATC button price label.
     *
     * ThemeEvents.variantUpdate is the string key for the event name.
     * From Horizon source: 'variant:update'
     */
    sectionEl.addEventListener('variant:update', (event) => {
      const { resource } = event.detail;
      if (!resource) return;

      // Find the add-to-cart button closest to this variant-picker
      const variantPicker = event.target.closest('variant-picker');
      if (!variantPicker) return;

      const productFormComponent = variantPicker.closest('product-form-component');
      if (!productFormComponent) return;

      const btn = productFormComponent.querySelector('.stl-card__atc');
      if (!btn) return;

      const defaultText = btn.querySelector('.add-to-cart-text--default');
      if (!defaultText) return;

      // Format price using Shopify's money formatter
      const priceFormatted = typeof Shopify !== 'undefined' && Shopify.formatMoney
        ? Shopify.formatMoney(resource.price, Shopify.money_format)
        : (resource.price / 100).toFixed(2);

      if (resource.available) {
        defaultText.innerHTML =
          'Add to cart'
          + '<span class="stl-card__atc-price"> — ' + priceFormatted + '</span>';
      } else {
        defaultText.textContent =
          'Sold out';
      }
    });

    /**
     * Keep the visible "Option — Selected Value" legend text in sync.
     * variant-picker re-renders its own HTML via DOM morphing, so the
     * checked radio state is always accurate. We just mirror it into
     * the legend's .stl-card__option-selected span.
     */
    sectionEl.addEventListener('change', (e) => {
      const input = e.target;
      if (!input.closest('variant-picker')) return;

      const fieldset = input.closest('fieldset');
      if (!fieldset) return;

      const selectedSpan = fieldset.querySelector('.stl-card__option-selected');
      if (!selectedSpan) return;

      const value = input.tagName === 'SELECT'
        ? input.options[input.selectedIndex]?.text
        : input.value;

      if (value) selectedSpan.textContent = ' \u2014 ' + value;
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
